import { addToCartPublisher } from "../../loaders/cart/addToCartPublisher";

/** Кейсы для добавления товара в корзину */
export const addToCartCases = (builder: any) => {
    builder
        .addCase(addToCartPublisher.pending, (state: any) => {
            state.loading.addedCartElement = true;
        })
        .addCase(addToCartPublisher.fulfilled, (state: any, action: any) => {
            const {data, isShowPopup} = action.payload;
            if (isShowPopup) {
                state.addedCartElement = data.cartElement;
            }
            state.loading.addedCartElement = false;
        })
        .addCase(addToCartPublisher.rejected, (state: any, action: any) => {
            state.error.addedCartElement = action.payload;
            state.loading.addedCartElement = false;
        });
};